(function () {
    'use strict';

    angular.module('app.book', [
        'app.core'
    ]);
})();
